export default function BackgroundAnimation() {
  return (
    <>
      {/* Base dark background */}
      <div style={{
        position: 'fixed', inset: 0, zIndex: 0,
        background: '#060708',
        pointerEvents: 'none',
      }} />

      {/* Noise texture overlay */}
      <div style={{
        position: 'fixed', inset: 0, zIndex: 0,
        pointerEvents: 'none',
        opacity: 0.03,
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
        backgroundSize: '256px 256px',
      }} />

      {/* Glowing orbs */}
      <div style={{ position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none', overflow: 'hidden' }}>

        {/* Top left — main green */}
        <div style={{
          position: 'absolute',
          top: '-20%', left: '-10%',
          width: 700, height: 700,
          borderRadius: '50%',
          background: 'radial-gradient(circle at center, rgba(0,255,136,0.12) 0%, rgba(0,255,136,0.04) 40%, transparent 70%)',
          animation: 'orb1 18s ease-in-out infinite',
          willChange: 'transform',
        }} />

        {/* Top right — blue */}
        <div style={{
          position: 'absolute',
          top: '-10%', right: '-15%',
          width: 600, height: 600,
          borderRadius: '50%',
          background: 'radial-gradient(circle at center, rgba(77,159,255,0.09) 0%, rgba(77,159,255,0.03) 40%, transparent 70%)',
          animation: 'orb2 24s ease-in-out infinite',
          willChange: 'transform',
        }} />

        {/* Center — faint green pulse */}
        <div style={{
          position: 'absolute',
          top: '30%', left: '30%',
          width: 900, height: 900,
          borderRadius: '50%',
          background: 'radial-gradient(circle at center, rgba(0,255,136,0.04) 0%, transparent 60%)',
          animation: 'orb3 32s ease-in-out infinite',
          willChange: 'transform',
          transform: 'translate(-50%, -50%)',
        }} />

        {/* Bottom left — purple */}
        <div style={{
          position: 'absolute',
          bottom: '-20%', left: '5%',
          width: 550, height: 550,
          borderRadius: '50%',
          background: 'radial-gradient(circle at center, rgba(176,109,255,0.08) 0%, rgba(176,109,255,0.02) 40%, transparent 70%)',
          animation: 'orb1 26s ease-in-out infinite reverse',
          willChange: 'transform',
        }} />

        {/* Bottom right — green */}
        <div style={{
          position: 'absolute',
          bottom: '-5%', right: '-5%',
          width: 450, height: 450,
          borderRadius: '50%',
          background: 'radial-gradient(circle at center, rgba(0,255,136,0.07) 0%, rgba(0,255,136,0.02) 40%, transparent 70%)',
          animation: 'orb2 20s ease-in-out infinite reverse',
          willChange: 'transform',
        }} />

        {/* Subtle grid lines */}
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.015) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.015) 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px',
          maskImage: 'radial-gradient(ellipse at center, transparent 20%, black 80%)',
          WebkitMaskImage: 'radial-gradient(ellipse at center, transparent 20%, black 80%)',
        }} />

      </div>

      <style>{`
        @keyframes orb1 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          25%       { transform: translate(40px, -30px) scale(1.05); }
          50%       { transform: translate(20px, 40px) scale(0.95); }
          75%       { transform: translate(-30px, 10px) scale(1.03); }
        }
        @keyframes orb2 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          25%       { transform: translate(-50px, 30px) scale(1.08); }
          50%       { transform: translate(-20px, -40px) scale(0.94); }
          75%       { transform: translate(40px, -20px) scale(1.04); }
        }
        @keyframes orb3 {
          0%, 100% { transform: translate(-50%, -50%) scale(1); }
          33%       { transform: translate(-50%, -50%) scale(1.12); }
          66%       { transform: translate(-50%, -50%) scale(0.92); }
        }
      `}</style>
    </>
  );
}
